import { render, staticRenderFns } from "./ProdutoDetalhe.vue?vue&type=template&id=8d6dbe82&"
import script from "./ProdutoDetalhe.vue?vue&type=script&lang=js&"
export * from "./ProdutoDetalhe.vue?vue&type=script&lang=js&"
import style0 from "./ProdutoDetalhe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports